import script from "./newFees.vue?vue&type=script&setup=true&lang=js"
export * from "./newFees.vue?vue&type=script&setup=true&lang=js"

import "./newFees.vue?vue&type=style&index=0&id=14f39b62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f39b62"]])

export default __exports__